import { useState, useEffect, useContext } from "react";
import { PatrimonioContext } from "../../../contexts/patrimonioProvider";
import { UserContext } from "../../../contexts/userProvider";
import { BiTrash, BiPlus } from 'react-icons/bi';
import Cadastro from "./Types/cadastro";

const Marca = (props) => {
  const { marcasByFornecedor, deleteMarca } = useContext(PatrimonioContext);
  const { setAlert } = useContext(UserContext);
  const [newMarcas, setNewMarcas] = useState([]);
  const [cadastroModal, setCadastroModal] = useState(false);
  const [marcaSelecionada, setMarcaSelecionada] = useState(null);

  useEffect(() => {
    receberMarcas();
  }, [props.fornecedor]);

  const receberMarcas = async () => {
    const dados = await marcasByFornecedor(props.fornecedor.id);
    setNewMarcas(dados);
  };

  const handleSelectMarca = (e) => {
    const { value } = e.target;
    const newMarca = newMarcas.find((marca) => marca.id === parseInt(value));
    setMarcaSelecionada(newMarca);
    props.setMarca(newMarca);
  };

  const handleAddMarca = () => {
    setCadastroModal(true);
  };

  const handleDeleteMarca = () => {
    if (!marcaSelecionada) return setAlert({ type: 'warning', message: 'Selecione uma marca para deletar!' })
    setAlert({
      type: 'confirm',
      placeholder: `Realmente deseja deletar a marca ${marcaSelecionada.nome}?`,
      visible: true,
      confirm: true,
      title: 'Atenção!',
      callback: () => deleteMarca(marcaSelecionada.id),
      params: marcaSelecionada.id
    })
  }
  return (
    <div className="space-y-4">
      <div className="flex items-end space-x-3">
        <div className="flex-1 space-y-2">
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
            Marca
          </label>
          <select
            className="w-full px-4 py-3 bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-lg text-gray-900 dark:text-white focus:ring-2 focus:ring-vox-blue-500 focus:border-vox-blue-500 transition-colors duration-200"
            onChange={handleSelectMarca}
          >
            <option value="">Selecione a marca</option>
            {newMarcas &&
              newMarcas
                .slice()
                .sort((a, b) => a.nome.localeCompare(b.nome))
                .map((marca, index) => (
                  <option key={index} value={marca.id}>
                    {marca.nome}
                  </option>
                ))}
          </select>
        </div>
        
        <button
          onClick={handleAddMarca}
          className="flex items-center justify-center w-12 h-12 bg-gradient-to-r from-vox-green-500 to-vox-green-600 hover:from-vox-green-600 hover:to-vox-green-700 text-white rounded-lg shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-200"
          title="Adicionar Marca"
        >
          <BiPlus size={20} />
        </button>
      </div>

      {cadastroModal && (
        <Cadastro
          fornecedor={props.fornecedor}
          receberMarcas={receberMarcas}
          setCadastroModal={setCadastroModal}
        />
      )}
    </div>
  );
};

export default Marca;
